import LayoutPopup from '@components/BannerAds/LayoutPopup';
import Breadcrumb from "@components/Breadcrumb/BreadcrumbPageCategory";
import Footer from '@components/Footer'
import HeaderBanner from "@components/HeaderBanner";
import Menu from "@components/Menu/index";
import SlickBroker from "@components/SlickBroker";
import { Col,Row } from "antd";
import dynamic from 'next/dynamic';
import React, { useState } from "react";
import useTranslate from 'src/hook/useTranslate';

import style from "./Layout.module.scss";

// dynamic
const PopupDisclaimer = dynamic(() => import('@components/popup/PopupDisclaimer'), {
  ssr: false,
});
const HomeLeftScroll = dynamic(() => import('@components/BannerAds/HomeLeftScrollUp'), {
  ssr: false
});
const HomeRightScroll = dynamic(() => import('@components/BannerAds/HomeRightScrollUp'), {
  ssr: false
});
const ProfileUpdateInfoPopup = dynamic(() => import('@components/ProfileUpdateInfo/ProfileUpdateInfoPopup'), {
  ssr: false
});

const Layout = ({
  children,
  haveAds = false,
  brokers,
  header,
  breadcrumbPageCategory,
  breadcrumbPageTopic,
  featurePostGroups
}) => {
  const [isBannerHidden, setIsBannerHidden] = useState(false);
  const translate = useTranslate();

  return (
    <>
      {/* <SEO title="VnRebates - Kiến thức Forex, Price Action, Dịch vụ Rebates" /> */}
      <HeaderBanner setIsBannerHidden={setIsBannerHidden} />
      <SlickBroker brokers={brokers} 
              translate={translate} />
      <Menu 
        featurePostGroups={featurePostGroups} 
        translate={translate}
        isBannerHidden={isBannerHidden}
      />
      <>{header}</>
      <div className={style.container}>
        {haveAds && 
          <div className={style.bannerScroll}>
            <HomeLeftScroll />
          </div>
        }
        
        <div style={{ width: "100%" }}>
          <div className={style.mainContent}>
            {breadcrumbPageCategory && (
              <div className={style.pageBreadcrumb}>
                <Breadcrumb 
                  categories={breadcrumbPageCategory} 
                  translate={translate}
                />
              </div>
            )}
            {breadcrumbPageTopic && (
              <div className={style.pageBreadcrumb}>
                <Breadcrumb 
                  categories={breadcrumbPageTopic} 
                  translate={translate}
                />
              </div>
            )}
            
            {children}
          </div>
        </div>
        {haveAds && 
          <div className={style.bannerScroll}>
            <HomeRightScroll />
          </div>
        }
      </div>
      
      <LayoutPopup />
      <Footer />
      <ProfileUpdateInfoPopup />
    </>
  );
};

export default Layout;
